import { Grid } from '@design-systems/canvas-ui'
import { Table } from 'components/table-compat/table-compat'
import { Container } from 'components/container/Container'
import { BasicPlaceholder } from 'components/placeholder'
import { TitledTableData, buildDataTableObject } from 'utils/data'
import { getLocationFilters } from 'utils/api'
import { useAssetsProtectionStore } from 'hooks/assets-protection/useAssetsProtectionStore'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import useRefresh from 'hooks/utils/useRefresh'
import useCountdown from 'hooks/utils/useCountdown'
import { ErrorAlert } from 'components/error-fallback'
import { translateItem, translateTableData } from 'locales/utils'
import { useEssentials } from 'hooks/utils/useEssentials'

export const PayrollStore = () => {
    const { t, currentLocation, logout, env, session } = useEssentials()
    const { payroll } = TRANSLATION_KEYS.assetsProtection

    const filters = getLocationFilters(currentLocation)
    let { data, isLoading, isError, refetch, remove, error } =
        useAssetsProtectionStore({
            env,
            accessToken: session?.accessToken ?? '',
            location: currentLocation,
            filters,
        })
    useRefresh(refetch, remove)
    const count = useCountdown(5, logout, error as Error)

    if (isLoading) {
        return (
            <div className="placeholder-container" data-testid="placeholder">
                <BasicPlaceholder type="table" rows={5} columns={5} />
            </div>
        )
    }
    if (isError || !data) {
        return (
            <ErrorAlert error={error} count={count} onRetry={() => refetch()} />
        )
    }

    const derivedData = structuredClone(data)
    const [weekly, monthly, yearly] = derivedData

    return (
        <Container className="hc8-pt-4x">
            {[weekly, monthly, yearly].map(
                (titledTable: TitledTableData, index) => {
                    const { title, table } = titledTable
                    const translatedTableData = translateTableData({
                        t,
                        table,
                        translation: payroll,
                    })
                    const translatedTitle = translateItem({
                        t,
                        item: title,
                        translation: payroll,
                    })

                    return (
                        <Grid.Container
                            className="hc8-pv-4x"
                            key={title || index}
                        >
                            <Grid.Item
                                className="hc8-pb-none"
                                size={{
                                    xs: 12,
                                }}
                            >
                                <p className="hc8-pa-1x hc8-lh-body">
                                    {translatedTitle}
                                </p>
                            </Grid.Item>
                            <Grid.Item
                                className="hc8-pt-none"
                                size={{
                                    xs: 12,
                                }}
                            >
                                <Table
                                    data={buildDataTableObject({
                                        currentData: translatedTableData,
                                        widths: [60, 60, 70, 100, 100],
                                    })}
                                    name={title}
                                    scrollableWidth={true}
                                />
                            </Grid.Item>
                        </Grid.Container>
                    )
                },
            )}
        </Container>
    )
}
